import type { GlobalStylesProps, Theme } from '@mui/material'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/700.css'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/600.css'
import '@fontsource/open-sans/700.css'

const typographies2 = ['code1', 'code2', 'code3']

export const customTheme = (theme: Theme) =>
  ({
    typography: {
      fontFamily: 'Montserrat, "Open Sans", Arial, sans-serif',
      h1: { fontFamily: 'Montserrat, sans-serif', fontWeight: 700 },
      h2: { fontFamily: 'Montserrat, sans-serif', fontWeight: 700 },
      h3: { fontFamily: 'Montserrat, sans-serif', fontWeight: 700 },
      h4: { fontFamily: 'Montserrat, sans-serif', fontWeight: 600 },
      h5: { fontFamily: 'Montserrat, sans-serif', fontWeight: 600 },
      h6: { fontFamily: 'Montserrat, sans-serif', fontWeight: 600 },
      body1: { fontFamily: 'Open Sans, Arial, sans-serif', fontWeight: 400 },
      body2: { fontFamily: 'Open Sans, Arial, sans-serif', fontWeight: 400 },
      button: { fontFamily: 'Montserrat, sans-serif', fontWeight: 700 },
      caption: { fontFamily: 'Open Sans, Arial, sans-serif', fontWeight: 400 },
      overline: { fontFamily: 'Montserrat, sans-serif', fontWeight: 700 },
      subtitle1: { fontFamily: 'Montserrat, sans-serif', fontWeight: 600 },
      subtitle2: { fontFamily: 'Montserrat, sans-serif', fontWeight: 600 },
      ...typographies2.reduce(
        (acc, variant) => ({
          ...acc,
          [variant]: {
            fontFamily: 'Open Sans, Arial, monospace',
          },
        }),
        {},
      ),
    },
    palette: {
      primary: {
        main: '#22767C',
        light: '#58A5AB',
        dark: '#004A50',
        contrastText: '#FFFFFF',
        background: '#22767C14',
        relatedLight: '#EDF4F5',
      },
      secondary: {
        main: '#7C2276',
        light: '#AE52A5',
        dark: '#4D004A',
        contrastText: '#FFFFFF',
        background: '#D0B16C14',
        relatedLight: '#F5EDF4',
      },
      brand: {
        appBarMain: theme.palette.brand.appBarMain,
        appBarContrastText: theme.palette.brand.appBarContrastText,
      },
    },
  }) as Theme

export const globalStyles: GlobalStylesProps['styles'] = ({
  spacing,
  palette,
  typography,
}) => ({
  '.map-tooltip__content': {
    ...typography.caption,
    position: 'relative',
    padding: spacing(1, 1.5),
    borderRadius: spacing(0.5),
    backgroundColor: palette.black['90'],
    color: palette.common.white,
    transform: `translate(-50%, calc(-100% - ${spacing(3)}))`,
    display: 'flex',
    flexDirection: 'column',

    '&::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 'calc(100% - 1px)',
      left: '50%',
      width: 0,
      height: 0,
      marginLeft: spacing(-1),
      borderLeft: `${spacing(1)} solid transparent`,
      borderRight: `${spacing(1)} solid transparent`,
      borderTop: `${spacing(1)} solid ${palette.grey[900]}`,
    },
  },
})
